import { Component, Input } from '@angular/core';

import { TableButton } from '../../classes/button';

@Component({
  selector: 'uex-table-button',
  templateUrl: './button.component.html'
})
export class TableButtonComponent {
  @Input() button: TableButton;
}
